function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M620 648.614C620 674.294 481.21 695.114 310 695.114C138.79 695.114 0 674.294 0 648.614C0 630.434 69.57 614.684 170.96 607.044C212.77 603.884 260.01 602.114 310 602.114C330.55 602.114 350.63 602.414 370.05 602.984C512.52 607.184 620 626.013 620 648.614Z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M270 658.114C335.722 658.114 389 651.622 389 643.614C389 635.605 335.722 629.114 270 629.114C204.278 629.114 151 635.605 151 643.614C151 651.622 204.278 658.114 270 658.114Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.5 654.114C331.632 654.114 382 600.388 382 534.114C382 467.839 331.632 414.114 269.5 414.114C207.368 414.114 157 467.839 157 534.114C157 600.388 207.368 654.114 269.5 654.114Z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M305 605.114H235V669.114H305V605.114Z",
  fill: "#1D386B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M396.5 620.614L392.5 642.614L418.5 646.614L435.5 636.614L434.5 620.614H396.5Z",
  fill: "#575A89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.5 207.614C265.5 207.614 263.5 230.614 258.5 231.614C253.5 232.614 269.5 272.614 269.5 272.614H293.5L312.5 267.614L303.5 245.614C303.5 245.614 291.5 229.614 300.5 216.614C309.5 203.614 265.5 207.614 265.5 207.614Z",
  fill: "#A0616A"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M265.5 207.614C265.5 207.614 263.5 230.614 258.5 231.614C253.5 232.614 269.5 272.614 269.5 272.614H293.5L312.5 267.614L303.5 245.614C303.5 245.614 291.5 229.614 300.5 216.614C309.5 203.614 265.5 207.614 265.5 207.614Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.5 383.614C215.5 383.614 189.5 433.614 210.5 443.614C231.5 453.614 236.5 452.614 236.5 455.614C236.5 458.614 232.5 457.614 234.5 462.614C236.5 467.614 230.5 487.614 236.5 499.614C242.5 511.614 240.5 520.614 240.5 520.614C240.5 520.614 240.5 521.614 242.5 525.614C244.5 529.614 245.5 532.614 244.5 534.614C243.5 536.614 237.5 549.614 243.5 552.614C249.5 555.614 280.5 557.614 283.5 552.614C286.5 547.614 280.5 544.614 283.5 541.614C286.5 538.614 288.5 537.614 286.5 535.614C284.5 533.614 282.5 508.614 282.5 508.614C282.5 508.614 287.5 479.614 285.5 475.614C283.5 471.614 280.5 467.614 282.5 464.614C284.5 461.614 286.5 462.614 287.5 458.614C288.5 454.614 290.5 445.614 290.5 445.614L301.5 444.614L327.5 449.614C327.5 449.614 356.5 481.614 388.5 491.614C388.5 491.614 397.5 500.614 400.5 500.614C403.5 500.614 403.5 500.614 402.5 502.614C401.5 504.614 398.5 504.614 400.5 506.614C402.5 508.614 405.5 505.614 403.5 508.614C401.5 511.614 399.5 511.614 401.5 513.614C403.5 515.614 400.5 526.614 400.5 527.614C400.5 528.614 391.5 622.614 394.5 624.614C397.5 626.614 439.5 632.614 442.5 624.614C445.5 616.614 440.5 606.614 440.5 606.614C440.5 606.614 455.5 486.614 451.5 478.614C447.5 470.614 433.5 434.614 358.5 411.614C358.5 411.614 337.5 407.614 337.5 404.614C337.5 401.614 335.5 382.614 331.5 381.614C327.5 380.614 304.5 379.614 304.5 379.614L275.5 388.614L235.5 381.614L215.5 383.614Z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250.5 551.614L245.5 569.614C245.5 569.614 241.5 598.614 246.5 605.614C250.427 611.112 257.44 617.844 270.444 619.026C274.089 619.36 277.739 618.44 280.79 616.419C283.841 614.397 286.11 611.395 287.223 607.908C287.372 607.491 287.465 607.055 287.5 606.614C287.5 604.614 284.5 580.614 284.5 580.614L279.5 555.614L278.5 548.614L250.5 551.614Z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M396.5 637.614C396.5 637.614 391.5 632.614 390.5 637.614C389.5 642.614 385.5 663.614 392.5 664.614C399.5 665.614 466.5 675.614 473.5 671.614C480.5 667.614 493.5 661.614 485.5 658.614C477.5 655.614 454.5 646.614 454.5 646.614C454.5 646.614 441.5 629.614 439.5 628.614C437.5 627.614 426.5 629.614 421.5 633.614C416.5 637.614 396.5 637.614 396.5 637.614Z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.5 228.614C306.621 228.614 320.5 214.734 320.5 197.614C320.5 180.493 306.621 166.614 289.5 166.614C272.379 166.614 258.5 180.493 258.5 197.614C258.5 214.734 272.379 228.614 289.5 228.614Z",
  fill: "#A0616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M286.5 267.614L274.5 254.614L261.199 228.614C261.199 228.614 251.5 225.614 249.5 230.614C247.5 235.614 211.5 251.614 211.5 251.614C211.5 251.614 220.5 335.614 216.5 343.614C212.5 351.614 205.5 383.614 211.5 386.614C217.5 389.614 245.5 386.614 254.5 390.614C263.5 394.614 289.5 394.614 296.5 389.614C303.5 384.614 305.5 380.614 312.5 383.614C318.459 386.168 332.391 298.853 336.402 272.833C336.74 270.647 336.459 268.411 335.592 266.377C334.724 264.343 333.305 262.592 331.494 261.323C322.521 255.029 306.361 244.183 303.5 245.614C299.5 247.614 286.5 267.614 286.5 267.614Z",
  fill: "#575A89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M329.5 263.614C331.848 264.201 333.961 265.492 335.553 267.315C337.146 269.137 338.143 271.404 338.411 273.809L346.5 346.614C346.5 346.614 326.5 389.614 316.5 360.614C306.5 331.614 329.5 263.614 329.5 263.614Z",
  fill: "#575A89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327.5 353.614L349.5 347.614C349.5 347.614 353.5 375.614 357.5 375.614C361.5 375.614 343.5 391.614 334.5 389.614C325.5 387.614 312.5 380.614 311.5 375.614C310.5 370.614 320.5 349.614 320.5 349.614L327.5 353.614Z",
  fill: "#575A89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M266.098 210.987C268.206 206.339 267.84 200.917 269.583 196.12C270.516 193.551 272.03 191.233 274.008 189.347C275.985 187.461 278.372 186.057 280.981 185.245C283.591 184.434 286.353 184.237 289.051 184.67C291.749 185.102 294.311 186.153 296.536 187.739C298.778 189.338 301.025 191.583 303.762 191.278C306.708 190.95 309.337 187.662 312.046 188.867C315.049 190.202 314.238 195.584 317.28 196.827C318.881 197.481 320.773 196.474 321.697 195.011C322.505 193.474 322.945 191.771 322.983 190.035C323.402 185.77 323.782 181.256 321.932 177.39C321.154 176.08 320.476 174.712 319.904 173.3C319.58 171.981 319.45 170.622 319.518 169.266C319.501 164.253 319.135 159.024 316.613 154.691C313.813 149.884 308.638 146.81 303.239 145.469C297.84 144.128 292.184 144.334 286.641 144.803C277.478 145.579 267.922 147.241 260.703 152.938C259.721 153.655 258.877 154.542 258.209 155.557C257.576 156.764 257.128 158.059 256.881 159.399C255.32 165.755 252.98 171.894 249.914 177.676C248.438 180.127 247.233 182.731 246.318 185.441C245.553 188.196 245.604 191.335 247.207 193.702C248.512 195.63 250.597 196.657 252.236 198.233C253.86 199.794 254.62 202.797 256.419 203.979C257.989 205.012 259.87 204.283 261.472 205.377C263.528 206.782 263.676 209.861 266.098 210.987Z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.5 282.614L294.5 276.614C294.5 276.614 338.5 289.614 347.5 301.614C347.5 301.614 369.5 287.614 381.5 289.614L393.5 291.614L356.5 324.614L309.5 320.614L291.5 282.614Z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.5 276.614L248.5 333.614L307.5 362.614C307.5 362.614 313.016 365.614 317.258 362.614L356.5 344.614L393.5 291.614L356.5 310.614C356.5 310.614 352.5 302.614 344.5 306.614L289.5 276.614Z",
  fill: "#1D386B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.5 377.614L360.5 356.614C360.5 356.614 378.5 333.614 368.5 322.614C358.5 311.614 347.5 354.614 347.5 354.614L352.5 377.614Z",
  fill: "#A0616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.198 374.262L277.654 360.11C277.654 360.11 304.764 349.245 301.632 334.713C298.501 320.18 267.412 351.858 267.412 351.858L260.198 374.262Z",
  fill: "#A0616A"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M217 273.114H216C216 273.114 200.5 254.614 197.5 279.614C194.5 304.614 184.5 387.614 210.5 390.614C236.5 393.614 255 378.114 255 378.114C255 378.114 274 349.114 267 349.114C263.613 349.114 254.402 347.592 246 348.114C237.037 348.67 228.984 351.194 229.5 348.614C230.5 343.614 245 280.114 217 273.114Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.5 253.614L211.5 251.614C211.5 251.614 195.5 254.614 192.5 279.614C189.5 304.614 179.5 387.614 205.5 390.614C231.5 393.614 266.5 386.614 266.5 386.614C266.5 386.614 273.5 348.614 266.5 348.614C259.5 348.614 223.5 353.614 224.5 348.614C225.5 343.614 243.5 260.614 215.5 253.614Z",
  fill: "#575A89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338 366.114L349.027 349.213L356 377.114L338 385.114V366.114Z",
  fill: "#575A89"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M421.005 200.002C448.618 200.002 471.003 177.618 471.003 150.005C471.003 122.392 448.618 100.007 421.005 100.007C393.392 100.007 371.007 122.392 371.007 150.005C371.007 177.618 393.392 200.002 421.005 200.002Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468.142 133.329H437.336C438.673 144.01 438.682 155.779 437.361 166.473H468.208C470.008 161.314 470.999 155.773 470.999 150.001C470.999 144.152 469.986 138.544 468.142 133.329Z",
  fill: "#D32027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437.336 133.329H468.142C468.136 133.313 468.131 133.3 468.126 133.286C461.726 115.242 445.266 101.967 425.489 100.205C433.143 104.4 435.378 117.692 437.336 133.329Z",
  fill: "#0B0B0B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.49 199.792C445.303 198.027 461.786 184.706 468.16 166.615C468.177 166.567 468.191 166.519 468.209 166.473H437.361C435.419 182.194 433.175 195.58 425.49 199.792Z",
  fill: "#F3C515"
}), /*#__PURE__*/React.createElement("path", {
  d: "M371 150C371 155.774 371.991 161.313 373.791 166.473H439.935C441.256 155.778 441.247 144.01 439.91 133.329H373.857C372.013 138.544 371 144.152 371 150Z",
  fill: "#DB2727"
}), /*#__PURE__*/React.createElement("path", {
  d: "M373.872 133.286C373.867 133.3 373.862 133.313 373.856 133.329H439.91C437.952 117.692 433.143 104.401 425.49 100.205C424.01 100.074 422.513 100 420.999 100C399.248 100 380.75 113.892 373.872 133.286Z",
  fill: "#151515"
}), /*#__PURE__*/React.createElement("path", {
  d: "M439.935 166.473H373.791C373.807 166.519 373.822 166.567 373.839 166.615C380.69 186.059 399.213 199.999 420.999 199.999C422.513 199.999 424.01 199.925 425.49 199.792C433.175 195.58 437.994 182.194 439.935 166.473Z",
  fill: "#F8D12E"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M179.56 150.001H211C211 122.385 188.614 100 160.999 100C174.806 100 179.561 125.001 179.56 150.001Z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111 150.001H181.709C181.71 125.001 174.806 100 160.999 100C133.386 100 111 122.385 111 150.001Z",
  fill: "#F3F4F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.508 150.001C178.508 175 174.806 200 160.999 200C188.614 200 211 177.614 211 150.001H178.508Z",
  fill: "#D84141"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.709 150.001H111C111 177.614 133.386 200 160.999 200C174.806 200 181.709 175 181.709 150.001Z",
  fill: "#DC4D4E"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M249.806 21.6689C246.582 26.3488 244.131 31.6036 242.645 37.2515H265.389L249.806 21.6689Z",
  fill: "#29337A"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M276.997 2.00134C271.236 3.67906 265.901 6.35618 261.203 9.84799L276.997 25.6422V2.00134Z",
  fill: "#29337A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M262.378 90.9859C266.784 94.0696 271.708 96.4569 276.997 97.9972V76.3686L262.378 90.9859Z",
  fill: "#29337A"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M243.219 64.7633C244.872 70.1184 247.406 75.0865 250.643 79.506L265.386 64.7633H243.219Z",
  fill: "#29337A"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M250.631 20.5083C250.351 20.8905 250.076 21.2781 249.806 21.6697L265.389 37.2524H242.645C242.277 38.6552 241.976 40.0851 241.728 41.5346H271.659L250.631 20.5083Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M261.218 90.1609C261.598 90.4444 261.989 90.7142 262.377 90.9859L276.997 76.368V97.9965C278.401 98.4071 279.828 98.7616 281.279 99.0466V70.1001L261.218 90.1609Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M242.108 60.4811C242.419 61.9321 242.785 63.3611 243.218 64.7633H265.385L250.643 79.506C252.246 81.6967 254.024 83.7525 255.956 85.6536L281.128 60.4811H242.108Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M276.997 2.00134V25.6422L261.203 9.84883C259.025 11.4681 256.99 13.2657 255.104 15.2117L281.278 41.3862V0.951263C279.828 1.23795 278.402 1.59326 276.997 2.00134Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M276.997 64.6124L276.847 64.7633H276.997V64.6124Z",
  fill: "#D32030"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M281.129 60.4811H281.279V60.3304L281.129 60.4811Z",
  fill: "#D32030"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M300.371 41.5337H300.227V41.679L300.371 41.5337Z",
  fill: "#D32030"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M277.145 37.2524L276.997 37.104V37.2524H277.145Z",
  fill: "#D32030"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M281.279 41.386V41.5337H281.427L281.279 41.386Z",
  fill: "#D32030"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M304.508 86.9287V98.1369C309.866 96.637 314.862 94.2725 319.331 91.192L307.186 79.0475C306.216 82.4572 305.86 84.2199 304.508 86.9287Z",
  fill: "#252F6C"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M307.25 22.8996L320.507 9.64196C315.745 6.15395 310.341 3.49583 304.508 1.8616V13.3753C306.067 16.4976 306.198 18.8701 307.25 22.8996Z",
  fill: "#252F6C"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M331.151 79.7973C334.49 75.3059 337.092 70.236 338.782 64.7634H316.117L331.151 79.7973Z",
  fill: "#252F6C"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M339.355 37.2524C337.837 31.4852 335.313 26.1318 331.987 21.3784L316.112 37.2524H339.355Z",
  fill: "#252F6C"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M310.169 61.3283L313.604 64.7642L330.051 81.2105C330.424 80.7431 330.795 80.2774 331.152 79.7982L316.118 64.7642H338.783C339.215 63.3628 339.582 61.9332 339.892 60.482H310.49C310.442 61.0891 310.226 60.7252 310.169 61.3283Z",
  fill: "#E7E7E7"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M306.73 25.407L321.637 10.4993C321.263 10.2096 320.889 9.92147 320.507 9.64195L307.25 22.8996C307.387 23.4238 306.603 24.8702 306.73 25.407Z",
  fill: "#E7E7E7"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M304.508 12.454V1.86075C303.105 1.46765 301.677 1.13452 300.226 0.862816V6.03002C301.819 7.75734 303.247 9.92695 304.508 12.454Z",
  fill: "#E7E7E7"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M309.831 41.5337H340.273C340.026 40.0842 339.724 38.6552 339.356 37.2515H316.113L331.988 21.3775C330.427 19.148 328.693 17.0512 326.798 15.1083L308.917 32.9883C309.398 36.2316 309.614 38.1152 309.831 41.5337Z",
  fill: "#E7E7E7"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M306.464 78.3233L319.331 91.1926C321.472 89.7186 323.487 88.078 325.368 86.2971L308.442 69.3707C307.902 72.5011 307.261 75.5246 306.464 78.3233Z",
  fill: "#E7E7E7"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M300.227 93.3755V99.1346C301.678 98.8646 303.105 98.5298 304.509 98.1367V86.9285C303.247 89.4566 301.819 91.6505 300.227 93.3755Z",
  fill: "#E7E7E7"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M308.917 32.9883L326.797 15.1083C325.187 13.4551 323.461 11.9165 321.636 10.4993L307.586 24.5512C308.211 27.1612 308.494 30.1486 308.917 32.9883Z",
  fill: "#D71F28"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M288.504 0.061645C289.338 0.0213224 290.168 0 290.999 0C290.163 0 289.331 0.0213224 288.504 0.061645Z",
  fill: "#D32030"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M290.999 100C290.168 100 289.337 99.9772 288.506 99.9369C289.333 99.9787 290.163 100 290.999 100Z",
  fill: "#D32030"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M290.999 100C294.154 100 297.234 99.6945 300.227 99.1346V93.3755C297.6 96.2223 294.528 100 290.999 100Z",
  fill: "#D32030"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M340.272 41.5337H310.226C310.624 47.8046 310.576 54.2531 310.083 60.4811H339.892C340.613 57.0997 341 53.5961 341 50.0008C341 47.1128 340.743 44.2881 340.272 41.5337Z",
  fill: "#D71F28"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M310.169 61.3283C309.891 64.2826 308.923 66.5846 308.441 69.3715L325.367 86.2971C327.041 84.7102 328.607 83.0128 330.05 81.2105L313.604 64.7633L310.169 61.3283Z",
  fill: "#D71F28"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M300.227 6.40179V0.863663C297.235 0.305481 294.155 0 290.999 0C294.527 0 297.6 3.55578 300.227 6.40179Z",
  fill: "#D32030"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M304.508 89.0912C305.86 86.3817 307.02 83.2625 307.991 79.8535L304.508 76.3703V89.0912Z",
  fill: "#29337A"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M308.425 21.7248C307.371 17.6953 306.067 14.032 304.508 10.9097V25.6397L308.425 21.7248Z",
  fill: "#29337A"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M311.139 62.2978C311.196 61.6946 311.247 61.0891 311.296 60.4811H309.322L311.139 62.2978Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M304.508 25.6399V10.9091C303.246 8.38203 301.819 6.21095 300.226 4.4851V31.9099L308.826 23.3103C308.696 22.7734 308.56 22.2475 308.424 21.7233L304.508 25.6399Z",
  fill: "white"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M300.371 41.5337H311.44C311.223 38.1154 310.877 34.7522 310.396 31.5097L300.371 41.5337Z",
  fill: "white"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M300.227 95.5143C301.82 93.7869 303.247 91.6173 304.509 89.0903V76.3695L307.992 79.8526C308.791 77.0524 309.461 74.061 310.003 70.9308L300.227 61.1554L300.227 95.5143Z",
  fill: "white"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M300.227 95.5143V61.1554L310.002 70.9314C310.483 68.1437 310.861 65.2527 311.138 62.2978L309.321 60.4811H311.295C311.789 54.2529 311.837 47.8044 311.439 41.5337H300.37L310.395 31.5097C309.972 28.6691 309.45 25.9217 308.825 23.3109L300.227 31.9106V4.48573C297.6 1.63887 294.527 0 290.999 0C290.168 0 289.337 0.0213224 288.504 0.061645C286.045 0.184724 283.633 0.487249 281.279 0.951486V41.3862L255.104 15.2117C253.496 16.8713 252 18.6396 250.631 20.5084L267.375 37.2524L271.658 41.5346H241.728C241.259 44.2881 241 47.1128 241 50.0008C241 53.5969 241.388 57.0997 242.108 60.4811H281.129L255.957 85.6536C257.605 87.2728 259.36 88.7808 261.218 90.1607L281.278 70.1001V99.047C283.633 99.5113 286.046 99.8136 288.505 99.9369C289.337 99.9772 290.167 100 290.999 100C294.527 100 297.6 98.3611 300.227 95.5143Z",
  fill: "#E51D35"
});

var _ref42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 654.237,
  height: 682.114,
  fill: "white",
  transform: "translate(0 13)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  fill: "white",
  transform: "translate(371 100)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  fill: "white",
  transform: "translate(111 100)"
})));

var SvgCountryFlagsOverHead = function SvgCountryFlagsOverHead(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655,
    height: 696,
    viewBox: "0 0 655 696",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCountryFlagsOverHead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/country-flags-over-head.6cd10821.svg";
export { ForwardRef as ReactComponent };